import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/missions/school-checkbox.html";
import MissionService from "Sources/services/mission-service";

import "Styles/components/school-checkbox.scss";

class SchoolCheckbox
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.schoolCheckbox = options.school;
    this.selected = false;
  }

  get schoolCheckbox()
  {
    return this._schoolCheckbox;
  }

  set schoolCheckbox(schoolCheckbox)
  {
    this._schoolCheckbox = schoolCheckbox;
    this.updateSchoolCheckbox();
  }

  static setUpSchoolCheckbox(options)
  {
    let instance = new SchoolCheckbox(options);
    instance.render();
    if(options.selected)
    {
      instance.setSelected();
    }
    instance.setUpEventListeners();
    return instance;
  }

  setUpEventListeners()
  {
    const LABEL_BTN_ID = ".mission-label";

    let that = this;
    this.$element.find("[data-bind-target='school-checkbox-checkbox']").on("change", function(e)
    {
      that.toggleSelected();
    });
  }

  toggleSelected()
  {
    this.selected = !this.selected;
  }

  setSelected()
  {
    this.$element.find("[data-bind-target='school-checkbox-checkbox']").prop("checked", true);
    this.selected = true;
  }

  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.append(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateSchoolCheckbox();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  updateSchoolCheckbox() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $schoolCheckboxName = this.$element.find("[data-bind-target='school-checkbox-label']");
      $schoolCheckboxName.empty();

      if (utils.isNotNull(this.schoolCheckbox) && utils.isNotNull(this.schoolCheckbox.name) && utils.isNotNull(this.schoolCheckbox.key)) {
        $schoolCheckboxName.text(this.schoolCheckbox.name);
        $schoolCheckboxName.attr("for", "school-checkbox-" + this.schoolCheckbox.key);
      }

      let $schoolCheckboxBox = this.$element.find("[data-bind-target='school-checkbox-checkbox']");
      $schoolCheckboxBox.empty();

      if (utils.isNotNull(this.schoolCheckbox) && utils.isNotNull(this.schoolCheckbox.key)) {
        $schoolCheckboxBox.attr("id", "school-checkbox-" + this.schoolCheckbox.key);
      }

    }
  }

}

export default SchoolCheckbox;



// WEBPACK FOOTER //
// ./app/js/components/school-checkbox.js